import { render, staticRenderFns } from "./CompletedStudyForm.vue?vue&type=template&id=74f22900&scoped=true"
import script from "./CompletedStudyForm.vue?vue&type=script&lang=js"
export * from "./CompletedStudyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f22900",
  null
  
)

export default component.exports